export const setToStorage = (key, value) => {
  const data = typeof value === "string" ? value : JSON.stringify(value);
  sessionStorage.setItem(key, data);
};

export const getFromStorage = (key) => {
  const data = sessionStorage.getItem(key);
  try {
    return JSON.parse(data);
  } catch (e) {
    return data;
  }
};
